module.exports = __webpack_public_path__ + "static/media/filter.a3454614.svg";